import { render, staticRenderFns } from "./DonutChart96Template.vue?vue&type=template&id=3f353818&scoped=true"
import script from "./DonutChart96Template.vue?vue&type=script&lang=js"
export * from "./DonutChart96Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f353818",
  null
  
)

export default component.exports